const Unreachable = () => {
  window.location.href = 'https://dized.com/';
  return null;
};

export default Unreachable;
